import { ISelect } from '../../../../shared/types/shared';

export const ORBIT_ADDRESS_QUADRANT_OPTIONS: ISelect[] = [
    { id: 'Norte', name: 'Norte' },
    { id: 'Sur', name: 'Sur' },
    { id: 'Este', name: 'Este' },
    { id: 'Oeste', name: 'Oeste' },
];
